<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" md="12" sm="12">
        <iq-card class-name="iq-card-block iq-card-stretch" body-class="">
          <template v-slot:body>
            <b-row>
              <b-col lg="6" md="6" sm="6">
                <label class="typo__label">BDM/s</label>
                <multiselect
                  v-model="selectedBDMs"
                  tag-placeholder="Add this as new tag"
                  placeholder="Search or add a bdm"
                  label="name"
                  track-by="id"
                  :options="getBDMTeamMember"
                  :multiple="true"
                  :taggable="true"
                >
                </multiselect>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
      <b-col lg="12">
        <iq-card
          class-name="iq-card-block iq-card-stretch iq-card-height"
          body-class="row m-0 align-items-center pb-0"
        >
          <template v-slot:headerTitle>
            <div>
              <b-button
                class="mr-2"
                :class="{ primary: getBDMRecordType == 'settlements' }"
                @click="fnSelectRecordType('settlements')"
                >Settlements</b-button
              >
              <b-button
                class="mr-2"
                :class="{ primary: getBDMRecordType == 'leads' }"
                @click="fnSelectRecordType('leads')"
                >Leads</b-button
              >

              <b-spinner
                v-if="getDBDMIsDashboardLoading"
                label="Loading..."
                small
              ></b-spinner>
            </div>
          </template>
          <template v-slot:headerAction>
            <ul class="nav nav-pills">
              <li class="nav-item">
                <a
                  href="javascript:void(0);"
                  class="nav-link"
                  :class="{ active: getBDMPeriodMode == 'this-month' }"
                  @click="fnPeriod('this-month')"
                  >This month</a
                >
              </li>
              <li class="nav-item">
                <a
                  href="javascript:void(0);"
                  class="nav-link"
                  :class="{ active: getBDMPeriodMode == 'last-month' }"
                  @click="fnPeriod('last-month')"
                  >Last month</a
                >
              </li>
              <li class="nav-item">
                <a
                  href="javascript:void(0);"
                  class="nav-link"
                  :class="{ active: getBDMPeriodMode == 'this-year' }"
                  @click="fnPeriod('this-year')"
                  >This year</a
                >
              </li>
            </ul>
          </template>
          <template v-slot:body>
            <b-col md="8">
              <div
                v-if="
                  getBDMPeriodMode == 'this-month' &&
                  dataObj1 &&
                  dataObj1.labels
                "
              >
                <appBarChart :dataObj="dataObj1"></appBarChart>
              </div>
              <div
                v-if="
                  getBDMPeriodMode == 'last-month' &&
                  dataObj2 &&
                  dataObj2.labels
                "
              >
                <appBarChart :dataObj="dataObj2"></appBarChart>
              </div>
              <div
                v-if="
                  getBDMPeriodMode == 'this-year' && dataObj3 && dataObj3.labels
                "
              >
                <appBarChart :dataObj="dataObj3"></appBarChart>
              </div>
            </b-col>

            <b-col md="4">
              <appWDDashboardSummaryBDM
                v-if="getBDMPeriodMode == 'this-month' && dataObj1"
                :dataObj="dataObj1"
                :periodMode="'this-month'"
                :isRecordType="getBDMRecordType"
              ></appWDDashboardSummaryBDM>

              <appWDDashboardSummaryBDM
                v-if="getBDMPeriodMode == 'last-month' && dataObj2"
                :dataObj="dataObj2"
                :periodMode="'last-month'"
                :isRecordType="getBDMRecordType"
              ></appWDDashboardSummaryBDM>

              <appWDDashboardSummaryBDM
                v-if="getBDMPeriodMode == 'this-year' && dataObj3"
                :dataObj="dataObj3"
                :periodMode="'this-year'"
                :isRecordType="getBDMRecordType"
              ></appWDDashboardSummaryBDM>
            </b-col>
          </template>
        </iq-card>
      </b-col>

      <!-- Video guide -->
      <b-col lg="12">
        <iq-card class-name="iq-card-block iq-card-stretch iq-card-height">
          <template v-slot:headerTitle>
            <h4 class="card-title">Video guide</h4>
          </template>
          <template v-slot:body>
            <b-row>
              <b-col lg="2" v-for="(video, index) in videos" :key="index">
                <appVideoPlaceHolder
                  :title="video.title"
                  :coverImgUrl="video.imageUrl"
                  :videoUrl="video.url"
                ></appVideoPlaceHolder>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import moment from 'moment'
import bgImage from '../../assets/images/page-img/45.png'
import appVideoPlaceHolder from '../../components/wd/VideoPlaceHolder.vue'
import { mapGetters, mapActions } from 'vuex'
import appChartBox from '../../components/charts/ChartBox.vue'
import appBarChart from '../../components/charts/BarChart.vue'
import * as authService from '../../services/auth.service'
import appWDDashboardSummaryBDM from '../../components/wd/WDDashboardSummaryBDM.vue'
import {
  fnGetThisMonthData,
  fnGetLastMonthData,
  fnGetDashboardInformation,
  fnGetThisMonthLeadsData,
  fnGetLastMonthLeadsData,
  fnGetDashboardLeadsInformation
} from '../../Utils/dashboardReferralPartner'

export default {
  name: 'DashboardDealer',
  components: {
    appVideoPlaceHolder,
    appChartBox,
    appBarChart,
    appWDDashboardSummaryBDM
  },
  data() {
    return {
      videos: [
        {
          title: 'What is a Novated Lease',
          imageUrl: require('../../assets/images/video-tutorials/f1.jpg'),
          url: '/videos/music_novated_lease_explained.mp4'
        },
        {
          title: 'Save Tax & GST',
          imageUrl: require('../../assets/images/video-tutorials/f2.jpg'),
          url: '/videos/novated_lease_savings.mp4'
        },
        {
          title: 'SA Government Employees',
          imageUrl: require('../../assets/images/video-tutorials/f3.jpg'),
          url: '/videos/sa_government_employees.mp4'
        },
        {
          title: 'Options at the end of the lease',
          imageUrl: require('../../assets/images/video-tutorials/f4.jpg'),
          url: '/videos/options_at_the_end_of_the_lease.mp4'
        },
        {
          title: 'Which employees can we assist',
          imageUrl: require('../../assets/images/video-tutorials/f5.jpg'),
          url: '/videos/which_employees_can_we_asist_with_novated_leasing.mp4'
        }
        // {
        //   title: 'Move Your Body',
        //   imageUrl: require('../../assets/images/video-tutorials/f5.jpg'),
        //   url: 'https://www.youtube.com/watch?v=fNfe6WdXRdA'
        // },
        // {
        //   title: 'Try New Things',
        //   imageUrl: require('../../assets/images/video-tutorials/f6.jpg'),
        //   url: 'https://www.youtube.com/watch?v=s4ObxcdXoFE'
        // }
      ],

      selectedBDMs: '',
      dataSettlements: [],
      dataObj1: '',
      dataObj2: '',
      dataObj3: '',
      bgImageURL: bgImage,
      userObj: {},
      currentMonthInText: '',
      lastMonthInText: '',
      currentYearInText: ''
    }
  },
  computed: {
    ...mapGetters([
      'getBDMRecordType',
      'getBDMPeriodMode',
      'getUserById',
      'getDBDMIsDashboardLoading',
      'getDBDMThisMonthData',
      'getDBDMLastMonthData',
      'getDBDMLastYearData',
      'getDBDMThisMonthLeadsData',
      'getDBDMLastMonthLeadsData',
      'getDBDMLastYearLeadsData'
    ]),
    getBDMTeamMember() {
      return this.getUserById.bdm_users ?? []
    }
  },
  methods: {
    ...mapActions([
      'fetchBDMRecordType',
      'fetchBDMPeriodMode',
      'fetchUserById',
      'fetchDBDMThisMonthData',
      'fetchDBDMLastMonthData',
      'fetchDBDMLastYearData',
      'fetchDBDMThisMonthLeadsData',
      'fetchDBDMLastMonthLeadsData',
      'fetchDBDMLastYearLeadsData'
    ]),

    fnSelectRecordType(recordType) {
      this.fetchBDMRecordType(recordType)
      this.fnPeriod(this.getBDMPeriodMode)
    },

    // This month data
    fnPeriodThisMonth() {
      let thisMonthData = fnGetThisMonthData(
        this.getDBDMThisMonthData.data_settlement_quote
      )

      let obj = {
        series: [
          {
            data: thisMonthData.dataSettlements,
            name: ['Settlements']
          }
        ],
        labels: thisMonthData.dataLabels,
        colors: ['#1e3d73'],
        dataTotSettlement: thisMonthData.dataTotSettlement,
        dataTotInc: thisMonthData.dataTotInc
      }
      this.dataObj1 = obj
    },

    // Last month data
    fnPeriodLastMonth() {
      let lastMonthData = fnGetLastMonthData(
        this.getDBDMLastMonthData.data_settlement_quote
      )

      let obj = {
        series: [
          {
            data: lastMonthData.dataSettlements,
            name: ['Settlements']
          }
        ],
        labels: lastMonthData.dataLabels,
        colors: ['#1e3d73'],
        dataTotSettlement: lastMonthData.dataTotSettlement,
        dataTotInc: lastMonthData.dataTotInc
      }
      this.dataObj2 = obj
    },

    // Last year data
    fnPeriodLastYear() {
      let thisYearData = fnGetDashboardInformation(
        this.getDBDMLastYearData.data_settlement_quote
      )
      let obj = {
        series: [
          {
            data: thisYearData.dataSettlements,
            name: ['Settlements']
          }
        ],
        labels: thisYearData.dataLabels,
        colors: ['#1e3d73'],
        dataTotSettlement: thisYearData.dataTotSettlement,
        dataTotInc: thisYearData.dataTotInc
      }
      this.dataObj3 = obj
    },

    // This month all Leads
    fnPeriodThisMonthLeads() {
      let thisMonthData = fnGetThisMonthLeadsData(
        this.getDBDMThisMonthLeadsData.data
      )

      let obj = {
        series: [
          {
            data: thisMonthData.dataQuotes,
            name: ['Leads']
          }
        ],
        labels: thisMonthData.dataLabels,
        colors: ['#1e3d73'],
        dataTotQuotes: thisMonthData.dataTotQuotes
      }
      this.dataObj1 = obj
    },

    // Last month all Leads
    fnPeriodLastMonthLeads() {
      let lastMonthData = fnGetLastMonthLeadsData(
        this.getDBDMLastMonthLeadsData.data
      )

      let obj = {
        series: [
          {
            data: lastMonthData.dataQuotes,
            name: ['Leads']
          }
        ],
        labels: lastMonthData.dataLabels,
        colors: ['#1e3d73'],
        dataTotQuotes: lastMonthData.dataTotQuotes
      }
      this.dataObj2 = obj
    },

    // Last year all Leads
    fnPeriodLastYearLeads() {
      let thisYearData = fnGetDashboardLeadsInformation(
        this.getDBDMLastYearLeadsData.data
      )
      let obj = {
        series: [
          {
            data: thisYearData.dataQuotes,
            name: ['Leads']
          }
        ],
        labels: thisYearData.dataLabels,
        colors: ['#1e3d73'],
        dataTotQuotes: thisYearData.dataTotQuotes
      }
      this.dataObj3 = obj
    },

    async fnPeriod(periodMode) {
      await this.fetchBDMPeriodMode(periodMode)

      if (
        this.getBDMRecordType == 'settlements' &&
        this.getBDMPeriodMode == 'this-month'
      ) {
        this.fnPeriodThisMonth()

        return
      }

      if (
        this.getBDMRecordType == 'settlements' &&
        this.getBDMPeriodMode == 'last-month'
      ) {
        this.fnPeriodLastMonth()
        return
      }

      if (
        this.getBDMRecordType == 'settlements' &&
        this.getBDMPeriodMode == 'this-year'
      ) {
        this.fnPeriodLastYear()
        return
      }

      if (
        this.getBDMRecordType == 'leads' &&
        this.getBDMPeriodMode == 'this-month'
      ) {
        this.fnPeriodThisMonthLeads()
        return
      }

      if (
        this.getBDMRecordType == 'leads' &&
        this.getBDMPeriodMode == 'last-month'
      ) {
        this.fnPeriodLastMonthLeads()
        return
      }

      if (
        this.getBDMRecordType == 'leads' &&
        this.getBDMPeriodMode == 'this-year'
      ) {
        this.fnPeriodLastYearLeads()
        return
      }
    }
  },
  async created() {
    await this.fetchBDMRecordType('settlements')
    this.userObj = authService.getUserFromToken()
    await this.fetchUserById(this.userObj.id)

    await this.fetchDBDMThisMonthLeadsData({ selectedBDMs: this.selectedBDMs })
    await this.fetchDBDMLastMonthLeadsData({ selectedBDMs: this.selectedBDMs })
    await this.fetchDBDMLastYearLeadsData({ selectedBDMs: this.selectedBDMs })
    await this.fetchDBDMThisMonthData({ selectedBDMs: this.selectedBDMs })
    await this.fetchDBDMLastMonthData({ selectedBDMs: this.selectedBDMs })
    await this.fetchDBDMLastYearData({ selectedBDMs: this.selectedBDMs })

    this.currentMonthInText = moment().format('MMMM')
    this.lastMonthInText = moment().subtract(1, 'month').format('MMMM')
    this.currentYearInText = moment().format('YYYY')

    await this.fnPeriod(this.getBDMPeriodMode)
  },
  watch: {
    async selectedBDMs(val) {
      await this.fetchDBDMThisMonthLeadsData({ selectedBDMs: val })
      await this.fetchDBDMLastMonthLeadsData({ selectedBDMs: val })
      await this.fetchDBDMLastYearLeadsData({ selectedBDMs: val })
      await this.fetchDBDMThisMonthData({ selectedBDMs: val })
      await this.fetchDBDMLastMonthData({ selectedBDMs: val })
      await this.fetchDBDMLastYearData({ selectedBDMs: val })

      await this.fnPeriod(this.getBDMPeriodMode)
    }
  }
}
</script>

<style lang="scss" scoped>
.iq-card-body {
  flex: unset;
}
.btn.btn-secondary {
  background-color: var(--iq-light-primary);
  border: 0px solid transparent !important;
  border-radius: 10px;
  color: var(--iq-primary);
}
.btn.btn-secondary.primary {
  background-color: var(--iq-primary);
  border: 0px solid transparent !important;
  border-radius: 10px;
  color: var(--iq-white);
}
</style>
